import { selector, useRecoilValueLoadable, atom, useSetRecoilState } from 'recoil'
import request from '@/common/api'
import { HOSTS } from '@/common/utils/env'

// NOTE: 不要参考该文件写法,移步 entFunctionConfigAtom
export interface IExpiryConfigItem {
  /** 失效类型 */
  expiryType?: number;
  /** i18n化文案 */
  name?: string;
  /** 提示文案 */
  tips?: string;
  /** 是否需要填写 */
  needFillValue?: boolean;
  /** 失效周期值上限 */
  expiryValueLimit?: number;

  /** 超失效周期值上限提醒 */
  overExpiryValueLimitTips?: string;
}

export interface RuleConfigRes {
  /** 是否支持自取,仅false时隐藏 */
  showPickup: boolean;
  /** 预算费用配置 */
  budgetFeeConfig?: {
    currency: string,

    /** 是否启用津贴 预算下发 */
    useBudget: boolean,

    /** 是否启用钱包余额 批次下发 */
    useWallet: boolean,
    periodConfig: Array<{

      /** 周期类型 */
      periodType?: number;

      /** i18n化文案 */
      i18nTextValue?: string;

      /** 提示文案 */
      tips?: string;

      /** 上限额度 */
      amountLimit?: string;
      /** 周期配置列表 */
      expiryConfigList?: Array<IExpiryConfigItem>
    }>
  };

  /** 商户类别配置 */
  merchantCategoryConfig?: Array<{

    /** 品类编码 */
    categoryCode?: string;

    /** 品类名称 */
    categoryName?: string;

    /** 品类说明 */
    categoryDescription?: string;
  }>;
}
const API_PATH = '/api/entweb/rulePackage/config'

const fetchRuleConfig = () => request.get(`${HOSTS.BASE}${API_PATH}`)

// 添加一个刷新触发器
const refreshTrigger = atom({
  key: `${API_PATH}_refresh_trigger`,
  default: 0,
})


const ruleConfig = selector({
  key: API_PATH,
  get: async ({ get }) => {
    get(refreshTrigger)
    const data = await fetchRuleConfig()
    return data as RuleConfigRes
  },
})

/** 获取规则配置信息 */
const useRuleConfig = () => {
  const loadable = useRecoilValueLoadable(ruleConfig)
  const result =  loadable.state === 'hasValue' ? loadable.contents : undefined
  return result as RuleConfigRes
}

/** 提供刷新功能的钩子 */
const useRefreshRuleConfig = () => {
  const setRefreshTrigger = useSetRecoilState(refreshTrigger)

  return () => {
    // 增加计数器值触发刷新
    setRefreshTrigger(count => count + 1)
  }
}

export const ruleConfigAtomHook = {
  useRefresh: useRefreshRuleConfig,
  useData: useRuleConfig,
}

export default useRuleConfig